import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getShardCatalogDetails } from '../../../../api';

export const adminSearchShardCatalogDetailsGetSlice = createGetAsyncSlice({
	name: 'AdminSearchShardCatalogDetails',
	receive: true,
	request: true,
	requestHandler: getShardCatalogDetails,
	retainDataOnRequest: true
});
